import React from "react";
import "./AdCopies.css";
import SponsoredImg from "../../../assets/images/sponsored.png";
import FacebookIcon from "../../../assets/images/facebook.svg";

const AdCopies = ({ pageName, profilePic, caption, thumbnail, adPreviewLink }) => {
  return (
    <div className="adCopies">
      <div className="adCopies-heading">
        <img className="profilePic" src={profilePic} />
        <div>
          <h4>{pageName}</h4>
          <img src={SponsoredImg} />
        </div>
      </div>
      <p className="description">{caption}</p>
      <div className="adThumbnail">
        <img src={thumbnail} />
        <div className="cta">
          <div className="left">
            <h5>Pre-pay and save</h5>
            <p>Get extra 2000 off on orders above</p>
          </div>
          <button>Contact Us</button>
        </div>
      </div>
      {adPreviewLink && (
        <a style={{ textDecoration: "none" }} target="_blank" href={adPreviewLink}>
          <div className="facebook">
            <img src={FacebookIcon} />
            <p>View this ad on Facebook</p>
          </div>
        </a>
      )}
    </div>
  );
};

export default AdCopies;
